import {
  InstancedBufferAttribute, InstancedMesh, ShaderMaterial,
  PlaneGeometry, Object3D, AdditiveBlending, Group,
} from "three";
import vert from "../shaders/photon_flock.vert?raw";
import frag from "../shaders/photon_flock.frag?raw";
import { detectFromBrowser, settingsForTier } from "../engine/tier";
import type { Chapter } from "./index";

export function createCh0Photon(): Chapter {
  const settings = settingsForTier(detectFromBrowser());
  const count = settings.photonFlock;

  const geom = new PlaneGeometry(1, 1);
  const seeds = new Float32Array(count * 3);
  for (let i = 0; i < count * 3; i++) seeds[i] = Math.random();
  geom.setAttribute("iSeed", new InstancedBufferAttribute(seeds, 3));

  const mat = new ShaderMaterial({
    vertexShader: vert,
    fragmentShader: frag,
    uniforms: { uTime: { value: 0 }, uIntensity: { value: 0 } },
    transparent: true,
    blending: AdditiveBlending,
    depthWrite: false,
  });

  const mesh = new InstancedMesh(geom, mat, count);
  const dummy = new Object3D();
  for (let i = 0; i < count; i++) {
    dummy.updateMatrix();
    mesh.setMatrixAt(i, dummy.matrix);
  }
  mesh.instanceMatrix.needsUpdate = true;

  const group = new Group();
  group.add(mesh);
  group.visible = false;

  return {
    id: 0,
    enter(ctx) { ctx.scene.add(group); group.visible = true; },
    exit(_ctx) { group.visible = false; },
    update(_ctx, t, _dt, local) {
      mat.uniforms.uTime.value = t;
      mat.uniforms.uIntensity.value = local;
    },
  };
}
